<template lang="pug">
.layout
  .layout-content
    GlobalWrapper
      nuxt
  TheBottomTabBar
</template>

<script>
import GlobalWrapper from '../components/GlobalWrapper'
import TheBottomTabBar from '../components/TheBottomTabBar'

export default {
  middleware: ['Authenticated'],
  components: { TheBottomTabBar, GlobalWrapper },
}
</script>

<style lang="sass" scoped>
.layout
  min-height: 100vh
  display: flex
  flex-direction: column
  &-content
    flex: 1
    padding-bottom: 60px
</style>
